import { defineComponent as _defineComponent } from 'vue'
interface Props {
  size?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WebhookIcon',
  props: {
    size: { default: "20" }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})